module.exports = __webpack_public_path__ + "static/media/football-player-main-big.20cbf72c.png";